import * as React from 'react';

import BoxSign28 from './BoxSign28';

export const boxSign28 = () => <BoxSign28 />;

export default {
    title: 'Icon/Logo/BoxSign28',
    component: BoxSign28,
    parameters: {
        notes: "`import BoxSign28 from 'box-ui-elements/es/icon/logo/BoxSign28';`",
    },
};
